import { IonModal, IonButton, IonText } from "@ionic/react";
import "./AbandonExamenModal.css";

interface IAbandonExamenModalProps {
  isOpen: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export const AbandonExamenModal: React.FC<IAbandonExamenModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => onCancel()}
      className="abandon-examen-modal"
    >
      <div className="abandon-examen-wrapper">
        <IonText className="abandon-examen-header">Abandonar examen</IonText>
        <IonText className="abandon-examen-message">
          ¿Está seguro que desea abandonar? Se computará el examen como
          realizado y calculará la nota sobre lo respondido.
        </IonText>
        <div className="abandon-examen-buttons">
          <IonButton
            className="abandon-examen-btn-cancel"
            fill="outline"
            onClick={onCancel}
          >
            No
          </IonButton>
          <IonButton
            className="abandon-examen-btn-confirm"
            fill="solid"
            onClick={handleConfirm}
          >
            Sí
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};
